import React, {Component} from 'react'
import {withResize} from './../../../../hoc/withResize'
class ProductNav extends Component {

  componentDidMount() {
    this.span =  this.list.querySelectorAll('span')
    this.max = this.list.offsetWidth
    if (this.props.viewport.isMobile) this.spanPos()
  }

  componentWillReceiveProps({viewport}){
    if (!viewport.isMobile) this.resetSpan()
    else this.spanPos()
  }

  componentWillUnmount() {
    this.resetSpan()
  }

  spanPos = () => {
    for(const item of this.span) {
      if (item.parentElement.offsetLeft + item.offsetWidth >= this.max ) {
        item.classList.add('reverse')
        if (item.parentElement.offsetLeft - item.offsetWidth < 0 ) item.style.transform = `translateX(${item.offsetWidth - item.parentElement.offsetLeft}px)`
      }
    }
  }

  resetSpan = () => {
    for(const item of this.span) {
      item.classList.remove('reverse')
      item.style.transform = 'none'
    }
  }

  updateSlides = (index) => (e) => {
    e.preventDefault()
    this.props.callback(index)
  }

  // capitalizing = (words) => {
  //   return words.toLowerCase().split(' ').reduce((acc, current) => {
  //     return `${acc} ${current.charAt(0).toUpperCase()}${current.substring(1)}`
  //   }, '')
  // }
  
  render () {
    const {panels, active} = this.props
    return (
      <div className='nav'>
        <ul className='reset flex items-center' ref={(elt) => this.list = elt}>
          {
            panels && panels.summary.map((slide, index) => (
              <li 
                key={index} 
                className={ index === active ? 'active' : '' } 
                onClick={this.updateSlides(index)}>
                <span>
                  { 
                  // slide.type === 'introproduct' ? 
                  //   this.capitalizing(slide.fields.bottomLabel) : 
                  //   this.capitalizing(slide.title)
                  slide.type === 'introproduct' ? 
                    slide.fields.bottomLabel : 
                    slide.title
                  }</span>
              </li>
            ))
          }
        </ul>
    </div>
    )
  }
}

export default withResize(ProductNav)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductNav.js